export const COLORS = {
  red: "#d0021b",
  // red: "#FF0012",
  gray: "#9b9b9b",
  gray2: "#979797",
  gray3: "#b8b8b8",
  gray4: "#5e5e5e",
  light: "#e1e1e1",
  white: "#ffffff",
  grohe: "#292929",
};

const COLOR_THEMES = {
  "qc": {
    primary: "#4A90E2",
    primary_hover: "#3483de", //darken(#4A90E2, 5%),
    active: "#9FC522",
    active_hover: "#8daf1e", //darken(#9FC522, 5%),
    assetsPath: "../images",
  },
  "caes": {
    primary: "#58595b",
    primary_hover: "#4b4c4e", //darken(#58595b, 5%),
    active: "#f46c42",
    active_hover: "#f3592a", //darken(#f46c42, 5%),
    assetsPath: "../images-caes",
  },
  // "as": {
  //   primary: "#36919B",
  //   primary_hover: "#4CABB5", //darken(#58595b, 5%),
  //   active: "#004D58",
  //   active_hover: "#4CABB5", //darken(#f46c42, 5%),
  //   assetsPath: "../images-caes",
  // },
  "moderno": {
    primary: "#343434",
    primary_hover: "#1b1b1b", //darken(#58595b, 5%),
    active: "#d0021b",
    active_hover: "#9d0214", //darken(#f46c42, 5%),
    assetsPath: "../images-moderno",
  },
  "look": {
    primary: "#000000",
    primary_hover: "#0b1f37", //darken(#58595b, 5%),
    active: "#3984BE",
    active_hover: "#3376aa", //darken(#f46c42, 5%),
    assetsPath: "../images",
  },
  "grohe": {
    primary: "#000000", // "#0F2B4C",
    primary_hover: "#0b1f37", //darken(#58595b, 5%),
    active: "#3984BE",
    active_hover: "#3376aa", //darken(#f46c42, 5%),
    assetsPath: "../images",
  },
  "as": {
    primary: "#000000", // "#0F2B4C",
    primary_hover: "#0b1f37", //darken(#58595b, 5%),
    active: "#E70026",
    active_hover: "#ce0022", //darken(#f46c42, 5%),
    assetsPath: "../images-as",
  },
  "nhance": {
    primary: "#000000", // "#0F2B4C",
    primary_hover: "#0b1f37", //darken(#58595b, 5%),
    active: "#ef7038",
    active_hover: "#ed5f20", //darken(#f46c42, 5%),
    assetsPath: "../images-nhance",
  },
}

export const GROHE_FILTER_COLORS = {
  "GROHE CHROME": "#f4f4f3", // R:244 G:244 B:243
  "GROHE POLISHED NICKEL": "#e4e0cb", // R:228 B:224 G:203
  "GROHE HARD GRAPHITE": "#605754", // R:96 G:87 B:84
  "GROHE BRUSHED NICKEL": "#c8beb1", // R:200 G:190 B:177
  "GROHE BRUSHED COOL SUNRISE": "#bb9759" // R:187 G:151 B:89
};

export default COLOR_THEMES
